'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var CurveArrowRight = function (_BaseIcon) {
  (0, _inherits3.default)(CurveArrowRight, _BaseIcon);

  function CurveArrowRight() {
    (0, _classCallCheck3.default)(this, CurveArrowRight);
    return (0, _possibleConstructorReturn3.default)(this, (CurveArrowRight.__proto__ || (0, _getPrototypeOf2.default)(CurveArrowRight)).apply(this, arguments));
  }

  (0, _createClass3.default)(CurveArrowRight, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M10.15 0l4.83 4.83-4.83 4.83-1.487-1.485L11.01 5.83H4.22c-.336 0-.647.02-.933.066-.285.045-.532.122-.74.227-.207.107-.367.258-.48.455-.11.196-.167.445-.167.748 0 .37.116.69.345.958.23.27.54.455.933.555l-.555 1.95c-.785-.213-1.418-.608-1.9-1.186C.24 9.028 0 8.254 0 7.292c0-.74.134-1.345.403-1.816.27-.47.61-.835 1.027-1.093.414-.258.863-.434 1.344-.53.483-.095.943-.142 1.38-.142h6.733L8.662 1.488 10.15 0z'
        }, this.getPathProps()))
      );
    }
  }]);
  return CurveArrowRight;
}(_BaseIcon3.default);
/*eslint-enable */


CurveArrowRight.defaultProps = {
  width: 16,
  height: 11,
  viewBox: '-1 0 16 11'
};
exports.default = CurveArrowRight;
//# sourceMappingURL=CurveArrowRight.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/CurveArrowRight.js
// module id = 288
// module chunks = 0